
import request from '@/libs/axios'

export function _GetAreaByPrefecture () {
  return request({
    url: 'prod-api/system/species/2023/prefecture/list',
    method: 'get'
  })
}

export function _GetAreaByCountry (prefecture) {
  return request({
    url: `prod-api/system/species/2023/country/list?prefecture=${prefecture}`,
    method: 'get'
  })
}
